import {Component, h, Fragment} from "preact";
import {t} from '../../_i18n';
import {E, Card, FR} from "../../_common/layout";
import {Link} from "react-router-dom";
import Dropdown from "../../_common/components/dropdown";
import {connect} from "react-redux";
import OfferBadgesContainer from '../../_common/components/offerBadgesContainer/OfferBadgesContainer'
import {
    updateOfferStatus,
    fetchOffers,
    fetchCompanyOffersCount,
    fetchCompanyOffersFilter
} from "../../_rx/jobs/actions";
import {formatDDMMYYYY, isMobileAgent, rndStr} from "../../_common/common";
import {OFFERS_LIMIT_PAGES} from "../../constants";
import {ModalLink} from "../../_common/components/modal";
import ModalDeleteDraft from '../components/modalDeleteDraft'
import './offerCard.scss'
import Badge from "../../_common/components/Badge";

const modalityFix: {[key:string]: string} = {
    modality_normal: 'Oferta de trabajo',
    modality_fct: 'Formación en centro de trabajo (FCT)',
    modality_dual: 'Dual'
}

const statuses : {[key:string]: string} = {
    "applied": t("Por leer"),
    "accepted": t("En proceso"),
    "selected": t("Finalistas"),
    "discarded": t("Descartados")
}


const mapStateBadges : {[key:string]: string} = {
    'applied': 'dark-gray',
    'accepted': 'dark-gray',
    'discarded': 'dark-red',
    'selected': 'dark-green'
}

const closedOffer: string = 'closed';
const publishedOffer: string = 'published';
const deleteOffer: string = 'delete';

type Props = {
    offer: any,
    academicPrograms: any,
    states: any,
    status: string,
    updateOfferStatus: typeof updateOfferStatus,
    fetchCompanyOffersCount: typeof fetchCompanyOffersCount,
    fetchCompanyOffersFilter: typeof fetchCompanyOffersFilter,
    fetchOffers: typeof fetchOffers,
    id: number,
    statusType: number,
    page: any,
    history: any,
    filter: any,
    loading: boolean
}

type State = {
    isMobile: boolean,
    academicProgramsOffer: any,
    idModalDelete: string
}



class OfferCard extends Component<Props, State> {

    state = {
        isMobile: isMobileAgent(),
        academicProgramsOffer: [],
        idModalDelete: rndStr(),
    }

    async updateOffer(status: string) {
        await this.props.updateOfferStatus({id:  this.props.id, status: {status: status}})
        await this.props.fetchOffers({status: this.props.statusType, limit: OFFERS_LIMIT_PAGES, page: this.props.page, ...this.props.filter});
        await this.props.fetchCompanyOffersCount({status: this.props.statusType, limit: OFFERS_LIMIT_PAGES, page: this.props.page, ...this.props.filter});
        await this.props.fetchCompanyOffersFilter({status: this.props.statusType});

    }

    componentDidMount() {
        this.setState({ academicProgramsOffer: this.props.offer.academicPrograms.map((id:any) => this.props.academicPrograms[id])})
    }

    render = ({ offer, academicPrograms, states, history, loading}:Props) => (states && academicPrograms && offer) && <Card smOnly={false} className='p-bottom offerCard'>
        <ModalDeleteDraft id={this.state.idModalDelete} history={history} handleDelete={() => this.updateOffer(deleteOffer)}/>
        {loading && <div className='loading-card' />}
        <FR className='flex-left'>
                <E className='col-80 sm-col-95'>
                    <Link to={`/offers/${offer.id}/applied`} className='no-decoration'><h1 className='no-margin txt-color-black' >{offer.title}</h1></Link>
                </E>
                <E className='col-15 sm-col-5'>
                    <Dropdown icon='fas fa-ellipsis-v txt-color-black' position='left' justIcon>
                        <div className='dropdown-item'><Link to={`/offers/${offer.id}/edit`}>{t('Editar oferta')}</Link></div>
                        <div className='dropdown-item'><Link to={{pathname: `/offers/${offer.id}/preview`, state: { prevPath: location.pathname }}} >{t('Previsualizar oferta')}</Link></div>
                        {this.props.status === 'drafts' && <div className='dropdown-item'>
                            <ModalLink id={this.state.idModalDelete}>
                                <span className={''}>{t('Eliminar borrador')}</span>
                            </ModalLink>
                        </div>}
                        <div className='dropdown-item__btn p-left p-right'>
                            {this.props.status === 'active' && <div className="btn btn-ghost danger  m-top" onClick={() => this.updateOffer(closedOffer)}><span className={'text-danger text-normal'}>{t('Cerrar Proceso')}</span></div>}
                            {this.props.status === 'drafts' && <div className="btn btn-ghost info  m-top" onClick={() => this.updateOffer(publishedOffer)}><span className={'text-info text-normal'}>{t('Publicar')}</span></div>}
                        </div>
                    </Dropdown>
                </E>
            </FR>

            <div className="p-top">
                <span className='font-medium'>{modalityFix[`modality_${offer.modality}`]}</span>
                {!this.state.isMobile ? <span className='translucent p-left p-right'>|</span> : <Fragment><br/><br/></Fragment>}
                {(offer.presence === 'remote')
                    ?<span className='translucent m-top'>{t('Teletrabajo')}</span>
                    :<span className='translucent m-top'>{states[offer.state]}</span>}
                {(offer.isRemoteProcess) && <Badge type='double-green' className='t-upper m-l sm-m-l no-margin-left font-12'><span>{t('proceso online')}</span></Badge>}

            </div>

            <FR className='p-top'>
                <OfferBadgesContainer academicProgramList={this.state.academicProgramsOffer} isMobile={this.state.isMobile} numberMax={55}/>
            </FR>

            <FR className="p-top">
                    <FR className="sm-col-85 col-100 flex-center-y">
                        {offer.counts && offer.counts.map((countItem: any, index: number) =><Fragment key={index}>
                            <div key={index} className='col-100 no-margin-top no-margin-bottom sm-d-none'>
                                <hr className="separator-xxs"/>
                                <Link to={'/offers/'+offer.id+'/'+countItem.state}>
                                <div className="d-flex flex-center-y flex-space-between">
                                    <div >{t(statuses[countItem.state])}</div>
                                    <div >
                                        <Badge type={mapStateBadges[countItem.state]} className='light'><span>{countItem.count}</span></Badge>
                                        <i className="fal fa-chevron-right p-left" />
                                    </div>
                                </div>
                                </Link>
                            </div>
                            <span className="d-none sm-d-iblock">
                                <Link to={'/offers/'+offer.id+'/'+countItem.state}><span>{t(statuses[countItem.state])}</span>
                                <Badge type={mapStateBadges[countItem.state]} className='m-l light'><span>{countItem.count}</span></Badge></Link>
                                {(index !== offer.counts.length -1) && <span className='p-left p-right'> | </span>}
                            </span>
                        </Fragment>
                        )}
                        <E className='sm-d-none col-100 no-margin-top'><hr className="separator-xxs"/></E>
                    </FR>
                <E className='sm-col-15 col-100 sm-t-right t-left no-margin-top'>
                    <E className='no-margin-top'><span className='translucent'>{(offer.date) && formatDDMMYYYY(offer.date)}</span></E>
                </E>
            </FR>
    </Card>
};

const ConnectedView: any = connect(
    ({}:any)=>({}), {updateOfferStatus, fetchOffers, fetchCompanyOffersCount, fetchCompanyOffersFilter})(OfferCard as any);


export default ({...props}) =>
        <ConnectedView {...props}/>
;
